export default "__VITE_ASSET__4bbfbc87__"